/* LEGAL: revisar com advogado antes de go-live */
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function PrivacyPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-full bg-surface">
      <div className="max-w-3xl mx-auto px-4 py-10">
        <button onClick={() => navigate(-1)} className="flex items-center gap-2 text-ink-muted hover:text-ink text-sm mb-8">
          <ArrowLeft className="w-4 h-4" /> Voltar
        </button>

        <div className="prose prose-sm max-w-none text-ink">
          <h1 className="font-display font-bold text-2xl text-ink mb-2">Política de Privacidade — MYND BPO</h1>
          <p className="text-xs text-ink-muted mb-8">Versão 1.1 — última atualização: julho de 2026 · Conforme Lei nº 13.709/2018 (LGPD)</p>

          <h2 className="font-semibold text-lg text-ink mt-6 mb-2">1. Controlador e Encarregado (DPO)</h2>
          <p className="text-ink-muted mb-4">
            A MYND ("MYND", "Plataforma", "nós") é a controladora dos dados pessoais tratados nesta plataforma.
            Dúvidas, requisições de titular e assuntos de privacidade devem ser encaminhados ao Encarregado de
            Proteção de Dados (DPO) pelo e-mail <a href="mailto:bemyndstore@gmail.com" className="text-brand-700">bemyndstore@gmail.com</a>.
          </p>

          <h2 className="font-semibold text-lg text-ink mt-6 mb-2">2. Dados coletados e finalidades</h2>
          <div className="overflow-x-auto mb-4">
            <table className="w-full text-sm border border-border rounded-xl overflow-hidden">
              <thead className="bg-surface-subtle">
                <tr>
                  <th className="px-4 py-2 text-left text-ink-muted font-medium">Dado</th>
                  <th className="px-4 py-2 text-left text-ink-muted font-medium">Finalidade</th>
                  <th className="px-4 py-2 text-left text-ink-muted font-medium">Base legal (LGPD)</th>
                </tr>
              </thead>
              <tbody>
                {[
                  ['E-mail e senha', 'Autenticação e acesso à conta', 'Execução de contrato (art. 7º, V)'],
                  ['Nome e CPF/CNPJ (obrigatório)', 'Identificação do titular, prevenção a fraudes e emissão de documentos', 'Execução de contrato e obrigação legal (art. 7º, II e V)'],
                  ['Dados financeiros (transações, contas, DRE, extratos importados)', 'Prestação do serviço de BPO financeiro', 'Execução de contrato (art. 7º, V)'],
                  ['Dados bancários via Open Finance (Pluggy) — saldos e transações', 'Sincronização e conciliação financeira, mediante autorização do titular no provedor', 'Consentimento (art. 7º, I) e execução de contrato'],
                  ['Dados de e-commerce (Mercado Livre) e tokens OAuth', 'Sincronização de pedidos, estoque e métricas da loja', 'Consentimento (art. 7º, I) e execução de contrato'],
                  ['Arquivos e referências enviados em cotações (Farms)', 'Permitir orçamento, modelagem e produção pela farm escolhida', 'Execução de contrato (art. 7º, V)'],
                  ['Conteúdo de conversas (chat) e denúncias', 'Comunicação entre as partes, segurança e mediação de disputas', 'Legítimo interesse e execução de contrato (art. 7º, V e IX)'],
                  ['Endereço IP, data/versão de aceite dos termos', 'Registro de consentimento e segurança', 'Cumprimento de obrigação legal (art. 7º, II)'],
                  ['Logs de acesso, uso e auditoria', 'Segurança, prevenção a fraudes e melhoria do serviço', 'Legítimo interesse (art. 7º, IX)'],
                  ['E-mail para comunicações (opt-in)', 'Envio de novidades e atualizações', 'Consentimento (art. 7º, I)'],
                ].map(([dado, fin, base]) => (
                  <tr key={dado} className="border-t border-border">
                    <td className="px-4 py-2 text-ink">{dado}</td>
                    <td className="px-4 py-2 text-ink-muted">{fin}</td>
                    <td className="px-4 py-2 text-ink-soft text-xs">{base}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <h2 className="font-semibold text-lg text-ink mt-6 mb-2">3. Dados sensíveis, financeiros e credenciais de integração</h2>
          <p className="text-ink-muted mb-4">
            Determinados tratamentos envolvem <strong>dados financeiros e credenciais de acesso a serviços de
            terceiros</strong> (por exemplo, tokens OAuth do Mercado Livre e dados bancários obtidos via Open
            Finance/Pluggy). Esses tratamentos só ocorrem <strong>após autorização expressa do titular</strong>,
            realizada no momento da conexão de cada integração. A MYND <strong>nunca</strong> armazena a senha do
            seu banco: a conexão Open Finance é feita diretamente no provedor licenciado, e a MYND recebe apenas
            tokens de leitura, guardados cifrados (AES-256-GCM). Você pode desconectar qualquer integração a
            qualquer momento, cessando a coleta futura.
          </p>

          <h2 className="font-semibold text-lg text-ink mt-6 mb-2">4. Consentimento para novas funcionalidades</h2>
          <p className="text-ink-muted mb-4">
            Quando uma atualização da Plataforma introduzir coleta de dados sensíveis, permanentes ou de novas
            fontes, você será informado por meio de aviso na Plataforma e, quando aplicável, seu
            <strong> consentimento específico será solicitado</strong> antes da ativação. Atualizações que não
            envolvam dados sensíveis são apenas comunicadas informativamente.
          </p>

          <h2 className="font-semibold text-lg text-ink mt-6 mb-2">5. Compartilhamento de dados</h2>
          <ul className="list-disc pl-5 text-ink-muted space-y-1 mb-4">
            <li><strong>Supabase Inc.</strong> — banco de dados, autenticação e funções (operador).</li>
            <li><strong>Cloudflare Inc.</strong> — hospedagem e CDN do frontend.</li>
            <li><strong>Pluggy</strong> — conexão Open Finance, quando você autoriza a integração bancária.</li>
            <li><strong>Mercado Livre / Mercado Pago</strong> — quando você autoriza a integração OAuth.</li>
            <li><strong>Resend</strong> — envio de e-mails transacionais (confirmação, recuperação, avisos).</li>
            <li>No módulo Farms, dados estritamente necessários do pedido são compartilhados com a farm escolhida para viabilizar o serviço.</li>
            <li>Autoridades públicas, quando exigido por lei ou ordem judicial.</li>
          </ul>

          <h2 className="font-semibold text-lg text-ink mt-6 mb-2">6. Seus direitos (LGPD, art. 18)</h2>
          <ul className="list-disc pl-5 text-ink-muted space-y-1 mb-4">
            <li><strong>Acesso e confirmação</strong> do tratamento e cópia dos dados.</li>
            <li><strong>Correção</strong> de dados incompletos, inexatos ou desatualizados.</li>
            <li><strong>Exclusão / anonimização</strong> de dados desnecessários ou tratados com base em consentimento.</li>
            <li><strong>Portabilidade</strong> em formato estruturado.</li>
            <li><strong>Revogação do consentimento</strong> a qualquer momento.</li>
            <li><strong>Oposição</strong> a tratamento baseado em legítimo interesse.</li>
          </ul>
          <p className="text-ink-muted mb-4">
            Requisições: <a href="mailto:bemyndstore@gmail.com" className="text-brand-700">bemyndstore@gmail.com</a>. Responderemos em até 15 dias.
          </p>

          <h2 className="font-semibold text-lg text-ink mt-6 mb-2">7. Segurança</h2>
          <ul className="list-disc pl-5 text-ink-muted space-y-1 mb-4">
            <li>Criptografia em repouso e tokens de integração cifrados (AES-256-GCM).</li>
            <li>Isolamento por empresa via Row Level Security (RLS) — cada conta acessa apenas seus dados.</li>
            <li>Comunicação protegida por TLS/HTTPS e auditoria de operações sensíveis.</li>
          </ul>

          <h2 className="font-semibold text-lg text-ink mt-6 mb-2">8. Retenção e exclusão da conta</h2>
          <p className="text-ink-muted mb-4">
            Dados financeiros e fiscais podem ser mantidos pelos prazos exigidos pela legislação (em regra, 5 anos).
            Ao solicitar a exclusão da conta, seus dados pessoais e operacionais são removidos e o login/senha
            eliminados. Para fins comerciais legítimos, de prevenção a fraudes e cumprimento de obrigações legais,
            a MYND <strong>retém um registro mínimo</strong> (e-mail, nome, documento e motivo de saída) de forma
            segregada. Um novo cadastro com o mesmo e-mail é tratado como um usuário inteiramente novo.
          </p>

          <h2 className="font-semibold text-lg text-ink mt-6 mb-2">9. Cookies</h2>
          <p className="text-ink-muted mb-4">
            Utilizamos apenas cookies estritamente necessários para autenticação e segurança da sessão. Não há
            cookies de rastreamento publicitário.
          </p>

          <h2 className="font-semibold text-lg text-ink mt-6 mb-2">10. Alterações desta política</h2>
          <p className="text-ink-muted mb-4">
            Esta Política pode ser atualizada. Mudanças relevantes serão notificadas na Plataforma e/ou por e-mail.
            A versão vigente está sempre disponível nesta página com a data de atualização.
          </p>
        </div>
      </div>
    </div>
  );
}
